import { Colors } from "src/com/sixdee/crbtportal/utils/resources/colors";
import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from "../../../../toolkit/uicomponentcss";

export interface CreateFlashMessageCSSStyle extends UIComponentCSSStyle
{
    getMobileConfirmButtonCSSStyle():object;
    getConfirmButtonCSSStyle(): object ;
    getConfirmButtonCSSStyle(): object;
    getHeaderDivCSSStyle(): object ;
    getTitleCSSStyle(): object ;
    getMobileCloseIconCSSStyle(): object ;
    getCloseIconDivCSSStyle(): object;
    getCloseIconCSSStyle(): object ;


}

export class CreateFlashMessageCSSStyleImpl extends UIComponentCSSStyleImpl implements CreateFlashMessageCSSStyle
{
    getWrapperCSSStyle(): object
    {
        return {
            height: "auto",
            width: "100%",
            borderRadius: "8px",
            backgroundColor: this.getResources().getColor(Colors.color_5),
            paddingBottom:'30px'

        };
    }
    
    
    getConfirmButtonCSSStyle(): object 
    {
        return {
            marginTop: "30px",
            width:'180px',
            height: "40px",
            marginLeft: "auto",
            marginRight: "auto",
        };
    }

    getMobileConfirmButtonCSSStyle():object
    {
        return {
            marginTop: "30px",
            width:'100px',
            height: "40px",
            marginLeft: "auto",
            marginRight: "auto",
        };
    }
    getHeaderDivCSSStyle(): object 
    {
        return {
            backgroundColor: this.getResources().getColor(Colors.color_18),
            width: "100%",
            height: "60px",
            display: "flex",
            borderRadius: "8px 8px 0px 0px",
        };
    }
    getTitleCSSStyle(): object {
        return {
            width: "380px",
            height: "40px",
            fontWeight: "300",
            letterSpacing: 0,
            paddingLeft: "40px",
            paddingRight: "0px",
            // fontSize: this.getResources().getFont(Fonts.h12),
            color:this.getResources().getColor(Colors.color_19),
            lineHeight: "40px",
            marginTop: "7px",
            textAlign: "center"
        };
    }

    getCloseIconDivCSSStyle(): object 
    {
        return {
            height: "60px",
            width: "60px",
            justifyContent: "center",
            textAlign: "center",
            alignItems: "center",
            display: "inline-block",
            cursor: "pointer"
        };
    }

    getCloseIconCSSStyle(): object 
    {
        return {
            height: "12px",
            width: "12px",
            marginTop: "22px",
            cursor: "pointer"
        };
    }

    getMobileCloseIconCSSStyle(): object 
    {
        return {
            height: "12px",
            width: "12px",
            marginRight: "10px",
            marginTop: "22px",
            cursor: "pointer"
        };
    }
}    



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/flashmessage/createflashmessage/createflashmessagecss.tsx